module.exports = __webpack_public_path__ + "media/images/closeX-8b7d387be235bad00f120d97027d994e.svg";